// extracted by mini-css-extract-plugin
export var banner = "styles-module--banner--08031";
export var banner_content = "styles-module--banner_content--60240";
export var banner_content__buttons = "styles-module--banner_content__buttons--12b93";
export var banner_content__left = "styles-module--banner_content__left--408a8";
export var banner_content__subtitle = "styles-module--banner_content__subtitle--0f487";
export var banner_content__title = "styles-module--banner_content__title--b1eb3";
export var banner_image = "styles-module--banner_image--9213b";
export var banner_imageDesktop = "styles-module--banner_image--desktop--c9d4a";
export var banner_imageMobile = "styles-module--banner_image--mobile--a8fb4";
export var banner_image__gatsby = "styles-module--banner_image__gatsby--55862";
export var banner_video__container = "styles-module--banner_video__container--6ae7a";
export var banner_video__thumbnail = "styles-module--banner_video__thumbnail--f1ab9";
export var belowImage = "styles-module--below-image--aaf3c";
export var subtitle__above = "styles-module--subtitle__above--61f4e";
export var subtitle__below = "styles-module--subtitle__below--a4583";
export var subtitle__stacked = "styles-module--subtitle__stacked--ede67";